// Mock Authentication Service
// This simulates AWS Cognito authentication with role-based access control

const MOCK_USERS = [
  {
    id: '1',
    username: 'admin@leadec.com',
    password: 'Admin@123',
    name: 'Admin User',
    role: 'ADMIN',
    permissions: ['view', 'create', 'edit', 'delete', 'manage_users', 'manage_sensors', 'view_reports']
  },
  {
    id: '2',
    username: 'manager@leadec.com',
    password: 'Manager@123',
    name: 'Operations Manager',
    role: 'MANAGER',
    permissions: ['view', 'create', 'edit', 'manage_sensors', 'view_reports']
  },
  {
    id: '3',
    username: 'operator@leadec.com',
    password: 'Operator@123',
    name: 'Warehouse Operator',
    role: 'OPERATOR',
    permissions: ['view', 'edit', 'view_reports']
  },
  {
    id: '4',
    username: 'viewer@leadec.com',
    password: 'Viewer@123',
    name: 'Viewer User',
    role: 'VIEWER',
    permissions: ['view']
  }
];

class AuthService {
  constructor() {
    this.currentUser = this.loadUserFromStorage();
  }

  loadUserFromStorage() {
    const userStr = localStorage.getItem('currentUser');
    return userStr ? JSON.parse(userStr) : null;
  }

  saveUserToStorage(user) {
    localStorage.setItem('currentUser', JSON.stringify(user));
  }

  removeUserFromStorage() {
    localStorage.removeItem('currentUser');
  }

  async login(username, password) {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 800));

    const user = MOCK_USERS.find(
      u => u.username === username && u.password === password
    );

    if (!user) {
      throw new Error('Invalid username or password');
    }

    // Remove password from stored user object
    const { password: _, ...userWithoutPassword } = user;
    this.currentUser = userWithoutPassword;
    this.saveUserToStorage(userWithoutPassword);

    return userWithoutPassword;
  }

  async logout() {
    // Simulate API call delay
    await new Promise(resolve => setTimeout(resolve, 300));
    
    this.currentUser = null;
    this.removeUserFromStorage();
  }

  getCurrentUser() {
    return this.currentUser;
  }

  isAuthenticated() {
    return this.currentUser !== null;
  }

  hasPermission(permission) {
    if (!this.currentUser) return false;
    return this.currentUser.permissions.includes(permission);
  }

  hasRole(role) {
    if (!this.currentUser) return false;
    return this.currentUser.role === role;
  }

  hasAnyRole(roles) {
    if (!this.currentUser) return false;
    return roles.includes(this.currentUser.role);
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;

